import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import Select from "react-select";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import DeleteModal from "../../../../components/DeletePopUpComponent";
import { Table } from "react-bootstrap";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import moment from "moment";
import * as Yup from "yup";

const AssetAllocationAdd = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Asset Allocation"));
  }, []);

  const intialFormData = {
    TXNDate: "",
    ContactID: null,
    lines: [
      {
        LineNo: 1,
        BatchNo: "",
        AssetID: "",
        Quantity: 1,
        ProjectID: null,
        Location: "",
        QuantityAllocated: 0,
        MRP: "",
        CategoryID: "",
      },
    ],
  };

  const [formData, setFormData] = useState(intialFormData);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [deleteType, setDeleteType] = useState("");
  const [errors, setErrors] = useState({});
  const [filterDate, setFilterDate] = useState(
    moment(new Date()).format("DD-MMM-YYYY")
  );
  const [loading, setLoading] = useState(false);
  const [filterSelectedEmp, setFilterSelectedEmp] = useState("");
  const [empOption, setEmpOption] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [categoryOption, setCategoryOption] = useState([]);
  const [assetOption, setAssetOption] = useState([]);
  const [assetLocationOpt, setAssetLocationOpt] = useState([]);

  useEffect(() => {
    fetchGetAssetAllocationData();
  }, []);

  const fetchGetAssetAllocationData = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}asset-allocation`);
      if (response.status === 200) {
        const emplst = response?.data?.empList?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setEmpOption(emplst);

        const CategoryLst = response?.data?.assetCategory?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setCategoryOption(CategoryLst);
        const assetLst = response?.data?.assetList?.map((ele) => ({
          value: ele?.AssetID,
          label: ele?.Name,
        }));
        setAssetOption(assetLst);

        const locationOpt = Object.entries(response?.data?.locations || {}).map(
          ([key, value]) => ({
            value: key,
            label: value,
          })
        );
        setAssetLocationOpt(locationOpt);

        setLoading(false);
        setPageLoading(false);
      } else {
        console.error(
          "Failed to fetch Asset Allocation. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Asset Allocation:", error);
    }
  };

  const [assetNamesByCategory, setAssetNamesByCategory] = useState([]);
  

  // Fetch asset names when component mounts or lines change
  // useEffect(() => {
  //   const fetchAssets = async () => {
  //     const uniqueCategories = [
  //       ...new Set(formData?.lines.map((line) => line.CategoryID)),
  //     ];
  //     const newAssetNames = { ...assetNamesByCategory };

  //     await Promise.all(
  //       uniqueCategories.map(async (categoryId) => {
  //         if (!newAssetNames[categoryId]) {
  //           try {
  //             const response = await GetServiceCaller(
  //               `${API_URL}support/procurement/get-asset-name?assetCategory=${categoryId}`
  //             );
  //             newAssetNames[categoryId] = response?.data || [];
  //           } catch (error) {
  //             console.error(
  //               `Error fetching assets for category ${categoryId}:`,
  //               error
  //             );
  //             newAssetNames[categoryId] = [];
  //           }
  //         }
  //       })
  //     );

  //     setAssetNamesByCategory(newAssetNames);
  //   };

  //   fetchAssets();
  // }, [formData?.lines]);

  useEffect(() => {
    if (filterSelectedEmp != "") {
      fetchGetEmpTableDetails(filterSelectedEmp);
    }
  }, [filterSelectedEmp]);
  const [assetAllocatedEntries, setAssetAllocatedEntries] = useState([]);
  const [displayAllocatedEntriesTable, setDisplayAllocatedEntriesTable] =
    useState(false);
  const [allocatedProjectOption, setAllocatedProjectOption] = useState([]);

  const fetchGetEmpTableDetails = async (id) => {
    try {
      const queryParams = new URLSearchParams({
        EmployeeName: id,
        AllocationDate: filterDate,
      });
      const response = await GetServiceCaller(
        `${API_URL}support/procurement/asset-allocation-details?${queryParams.toString()}`
      );
      if (response.status === 200) {
        const cleanedData = response?.data?.data;
        setDisplayAllocatedEntriesTable(true);
        setAssetAllocatedEntries(cleanedData);

        const projectList = response?.data?.allocatedProject?.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));

        setAllocatedProjectOption(projectList);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Vendor Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Vendor Master:", error);
    }
  };

  const handleAddAssetLine = () => {
    const currentRow = formData.lines[formData.lines.length - 1];

    if (currentRow && currentRow.CategoryID === "") {
      toast.error("Please fill in the current row.", {
        position: "top-right",
      });
      return;
    }

    const newLineNo = formData.lines.length + 1;

    setFormData((prevState) => ({
      ...prevState,
      lines: [
        ...prevState.lines,

        {
          LineNo: newLineNo,
          BatchNo: "",
          AssetID: "",
          Quantity: 1,
          QuantityAllocated: 0,
          MRP: "",
          CategoryID: "",
          ProjectID: null,
          Location: "",
        },
      ],
    }));
  };

  // const  = (selectedOption, name) => {
  //     setFilterSelectedEmp(selectedOption.value)

  //     console.log("selexted", selectedOption, name);

  // }

  const handleFilterSelect = async (selectedOption, name) => {
setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: selectedOption.value };

      // Update filterSelectedEmp
      setFilterSelectedEmp(selectedOption.value);

      // Trigger validation for the specific field after updating
      validateField(name, updatedData);

      return updatedData;
    });
  };

  const schema = Yup.object().shape({
    ContactID: Yup.number()
      .typeError("Allocated To is required")
      .required("Allocated To is required")
      .nullable(), // Allows the field to be null
    lines: Yup.array().of(
      Yup.object().shape({
        AssetID: Yup.number()
          .typeError("Asset To is required")
          .required("Asset To is required")
          .nullable(),
        CategoryID: Yup.number()
          .typeError("Category To is required")
          .required("Category To is required")
          .nullable(),
        ProjectID: Yup.string()
          // .typeError("Project is required")
          // .required("Project is required")
          .nullable(),
        Location: Yup.string()
          // .typeError("Location is required")
          .required("Location is required")
          .nullable(),
      })
    ),
  });
  const validateField = async (fieldName, updatedData) => {
    try {
      // Validate the specific field using Yup schema
      await schema.validateAt(fieldName, updatedData);

      // Clear any previous error for the validated field
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[fieldName]; // Delete error for the validated field
        return newErrors;
      });
    } catch (err) {
      // If validation fails, set the error for the specific field
      if (err.path === fieldName) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: err.message, // Set error for the validated field
        }));
      } else {
        console.error("Unexpected validation error structure:", err);
      }
    }
  };

  // const handleSelectChange = async (selectedOption, name, index) => {
  //   // Clone the formData to update the selected value
  //   const updatedLines = [...formData.lines];
  //   updatedLines[index] = {
  //     ...updatedLines[index],
  //     [name]: selectedOption?.value || "",
  //   };

  //   const updatedFormData = { ...formData, lines: updatedLines };
  //   setFormData(updatedFormData);

  //   // Only validate if the field is not empty
  //   if (selectedOption?.value) {
  //     // Clear errors for the selected field
  //     setErrors((prevErrors) => {
  //       const newErrors = { ...prevErrors };
  //       delete newErrors[`lines[${index}].${name}`]; // Remove specific error
  //       return newErrors;
  //     });

  //     // Run field-specific validation
  //     await validateField(`lines[${index}].${name}`, updatedFormData);
  //   }
  // };
  const handleSelectChange = async (selectedOption, name, index) => {
    // Clone the formData to update the selected value
    const updatedLines = [...formData.lines];
    updatedLines[index] = {
      ...updatedLines[index],
      [name]: selectedOption?.value || "",
    };
  
    const updatedFormData = { ...formData, lines: updatedLines };
    setFormData(updatedFormData);
  
    // Only validate if the field is not empty
    if (selectedOption?.value) {
      // Clear errors for the selected field
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[`lines[${index}].${name}`];
        return newErrors;
      });
  
      // Run field-specific validation
      await validateField(`lines[${index}].${name}`, updatedFormData);
  
      // 👇 Call API only when CategoryID is selected
      if (name === "CategoryID") {
        fetchAssetData(selectedOption.value, index);
      }
    }
  };
  const fetchAssetData = async (categoryId, index) => {
    try {
      const response = await GetServiceCaller(`${API_URL}support/procurement/get-asset-name?assetCategory=${categoryId}`);
      // You can update additional data in formData here if needed
      const assetData = response?.data?.data;
      const asset = assetData?.map((item) => ({
        value: item.ID,
        label: item.Name,
      }));
      setAssetNamesByCategory(asset);
    } catch (error) {
      console.error("Error fetching data for category:", error);
    }
  };
    
  const handleDateChange = (e) => {
    setFilterDate(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Construct payload
      const payload = {
        TXNDate: filterDate,
        ContactID: filterSelectedEmp,
        lines: formData?.lines?.map((ele) => ({
          LineNo: ele?.LineNo,
          BatchNo: ele?.BatchNo || null,
          AssetID: ele?.AssetID,
          ProjectID: ele?.ProjectID ||null,
          Location: ele?.Location,
          Quantity: 1, // Default Quantity to 1
          QuantityAllocated: ele?.QuantityAllocated,
          MRP: ele?.MRP|| null,
          CategoryID: ele?.CategoryID,
        })),
      };

      setFormData(payload);

      // Call the API

      await schema.validate(payload, { abortEarly: false });
      setErrors({});
      const response = await PostServiceCaller(
        `${API_URL}asset-allocation`,
        payload,
        "post"
      );

      // Handle API response
      if (response?.status === 200) {
        toast.success("Data submitted successfully");

        // Redirect after successful submission
        setTimeout(() => {
          navigate("/asset-allocation");
        }, 2000);
      } else {
        console.error(
          "Failed to submit data. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      // Handle validation errors

      if (error.name === "ValidationError") {
        console.error("Validation Error:", error);
        const validationErrors = {};
        error?.inner?.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        setErrors(validationErrors);
      } else {
        // Handle other unexpected errors
        console.error("Unexpected Error:", error);
      }
    } finally {
      // Always reset loading state
      setLoading(false);
    }
  };

  const fetchGetSerioNoApi = async (assetID, index) => {
    setLoading(true); // Set loading to true before the API call
    try {
      const response = await GetServiceCaller(
        `${API_URL}support-desk/reports/get-serial-no?AssetID=${assetID}`
      );

      if (response?.status === 200) {
        const serialNo = response?.data?.data?.[0]?.BatchNo;
        const price = response?.data?.data?.[0]?.MRP;

        // Update the specific index in 'lines'
        setFormData((prevData) => ({
          ...prevData,
          lines: prevData?.lines?.map(
            (line, idx) =>
              idx === index
                ? { ...line, BatchNo: serialNo, MRP: price } // Update the specific line
                : line // Keep other lines unchanged
          ),
        }));
      } else {
        console.error(
          `Failed to fetch serial numbers. Status: ${response?.status}`
        );
      }
    } catch (error) {
      console.error("Error fetching serial numbers:", error);
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  const openDeleteModal = (type, item) => {
    setShowDeleteModal(true);
    setSelectedDeleteItem(item);
    setDeleteType(type);
  };

  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setSelectedDeleteItem(null);
    setDeleteType("");
  };

  const handleModalDelete = () => {
    if (selectedDeleteItem && deleteType === "BrandLine") {
      setFormData((prevState) => ({
        ...prevState,
        lines: prevState.lines.filter((_, i) => i !== selectedDeleteItem.index),
      }));
    }
    handleDeleteClose();
  };

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
      <div className="Container">
              <form
                id="formOne"
                className="rounded mt-2 bg-white"
                onSubmit={handleSubmit}
              >
                <div class="card-body  mx-2">
                  <div className="row">
                    <div className="col-md-3">
                      <label className="form-label">
                        Allocation Date<span className="text-danger">*</span>
                      </label>
                      <CustomDatePicker
                        handleChange={(e) => handleDateChange(e)}
                        name="AllocationDate"
                        id="AllocationDate"
                        className="form-control"
                        value={filterDate}
                        placeholderText="DD-MM-YYYY"
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">
                        Allocated To<span className="text-danger">*</span>
                      </label>
                      <Select
                        name="ContactID"
                        onChange={(selectedOption, action) =>
                          handleFilterSelect(selectedOption, action.name)
                        }
                        placeholder="Allocation To"
                        className={` ${errors.ContactID ? "is-invalid" : ""}`}
                        options={[
                          { value: null, label: "Select" },
                          ...empOption,
                        ]}
                      />
                      {errors.ContactID && (
                        <div className="invalid-feedback">
                          {errors.ContactID}
                        </div>
                      )}
                    </div>
                  </div>

                  {/** Static Table Data */}
                  {displayAllocatedEntriesTable != false ? (
                    <div className="row mt-3">
                      <h5>
                        {assetAllocatedEntries.length || 0} Asset Allocated
                        Entries
                      </h5>
                      <div>
                        <Table bordered striped>
                          <thead id="thcolor" className="text-center">
                            <tr>
                              <th>Sr. No.</th>
                              <th>Category</th>
                              <th>Make</th>
                              <th>Asset</th>
                              <th>Serial No.</th>
                              <th>Project</th>
                              <th>Allocated Date</th>
                              <th>Allocated By</th>
                              <th>Status</th>
                              <th>Asset value</th>
                            </tr>
                          </thead>
                          <tbody>
                            {assetAllocatedEntries?.map((ele, index) => (
                              <tr>
                                <td className="text-center">{index + 1}</td>
                                <td>{ele?.CategoryName}</td>
                                <td>{ele?.Brand}</td>
                                <td>{ele?.AssetName}</td>
                                <td>{ele?.BatchNo}</td>
                                <td>{ele?.Project}</td>
                                <td className="text-center">
                                  {moment(ele?.TXNDate).format("DD-MMM-YYYY")}
                                </td>
                                <td>{ele?.AllocatedFromName}</td>
                                <td>{ele?.Status}</td>
                                <td>{ele?.MRP}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  ) : null}

                  {/** Static Table Data */}

                  {/** Add Row Data */}

                  <div className="row">
                    <div className="table-responsive brand-details rounded mt-2">
                      <div>
                        <div className="d-flex justify-content-between align-items-center">
                          <h5>Asset History</h5>
                          <button
                            type="button"
                            onClick={handleAddAssetLine}
                            className="custom-btn-sm"
                          >
                            <i className="fa fa-plus"></i>&nbsp;Add
                          </button>
                        </div>
                      </div>
                      <Table
                        style={{ background: "#ECECEC !important" }}
                        // id="poctable_head"
                        className="table table-bordered"
                      >
                        <thead
                          id="thcolor"
                          className="text-center align-middle  "
                        >
                          <tr>
                            <th>Sr. No.</th>
                            <th>
                              Category<span className="text-danger">*</span>
                            </th>
                            <th>
                              Project
                            </th>
                            <th>
                              Location<span className="text-danger">*</span>
                            </th>
                            <th>
                              Asset<span className="text-danger">*</span>
                            </th>
                            <th>Serial No.</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData?.lines?.map((ele, index) => (
                            <tr>
                              <td className="text-center align-middle">
                                {index + 1}
                              </td>
                              <td>
                                <Select
                                  name="CategoryID"
                                  onChange={(selectedOption, action) =>
                                    handleSelectChange(
                                      selectedOption,
                                      action.name,
                                      index
                                    )
                                  }
                                  placeholder="Category"
                                  menuPlacement="bottom"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 1050,
                                    }),
                                  }}
                                  className={` ${
                                    errors?.[`lines[${index}].CategoryID`]
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  options={[
                                    { value: null, label: "Select" },
                                    ...categoryOption,
                                  ]}
                                />
                                {errors?.[`lines[${index}].CategoryID`] && ( // Accessing errors for the specific line
                                  <div className="invalid-feedback text-center">
                                    {errors?.[`lines[${index}].CategoryID`]}{" "}
                                    {/* Displaying the error message */}
                                  </div>
                                )}
                              </td>
                              <td>
                                <Select
                                  name="ProjectID"
                                  onChange={(selectedOption, action) =>
                                    handleSelectChange(
                                      selectedOption,
                                      action.name,
                                      index
                                    )
                                  }
                                  placeholder="Project"
                                  className={` ${
                                    errors?.[`lines[${index}].ProjectID`]
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  value={allocatedProjectOption?.find(
                                    (o) => o.value === ele?.ProjectID
                                  )}
                                  menuPlacement="bottom"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 1050,
                                    }),
                                  }}
                                  options={[
                                    { value: null, label: "Select" },
                                    ...allocatedProjectOption,
                                  ]}
                                />
                                {errors?.[`lines[${index}].ProjectID`] && ( // Accessing errors for the specific line
                                  <div className="invalid-feedback text-center">
                                    {errors?.[`lines[${index}].ProjectID`]}
                                  </div>
                                )}
                              </td>
                              <td>
                                <Select
                                  name="Location"
                                  onChange={(selectedOption) =>
                                    handleSelectChange(
                                      selectedOption,
                                      "Location",
                                      index
                                    )
                                  }
                                  placeholder="Location"
                                  className={`${
                                    errors?.[`lines[${index}].Location`]
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  value={assetLocationOpt?.find(
                                    (o) => o.value === ele?.Location
                                  )}
                                  menuPlacement="bottom"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 1050,
                                    }),
                                  }}
                                  options={[
                                    { value: null, label: "Select" },
                                    ...assetLocationOpt,
                                  ]}
                                />
                                {errors?.[`lines[${index}].Location`] && (
                                  <div className="invalid-feedback text-center">
                                    {errors[`lines[${index}].Location`]}
                                  </div>
                                )}
                              </td>

                              <td>
                                <Select
                                  name="AssetID"
                                  onChange={(selectedOption, action) => (
                                    handleSelectChange(
                                      selectedOption,
                                      action.name,
                                      index
                                    ),
                                    fetchGetSerioNoApi(
                                      selectedOption.value,
                                      index
                                    )
                                  )}
                                  className={` ${
                                    errors?.[`lines[${index}].AssetID`]
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  placeholder="Asset"
                                  menuPlacement="bottom"
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 1050,
                                    }),
                                  }}

                                  options={assetNamesByCategory || []}
                                />
                                {errors?.[`lines[${index}].AssetID`] && ( // Accessing errors for the specific line
                                  <div className="invalid-feedback text-center">
                                    {errors?.[`lines[${index}].AssetID`]}{" "}
                                    {/* Displaying the error message */}
                                  </div>
                                )}
                              </td>

                              <td>
                                <input
                                  className="form-control"
                                  value={ele?.BatchNo}
                                  disabled
                                />
                                {/* <Select
                                                                    name="BatchNo"
                                                                    onChange={(selectedOption, action) =>
                                                                        handleSelectChange(selectedOption, action.name, index)
                                                                    }
                                                                    isDisabled={true}
                                                                    value={ele?.BatchNo}
                                                                    placeholder="Serial No "
                                                                    menuPlacement="bottom"
                                                                    menuPortalTarget={document.body}
                                                                    styles={{
                                                                        menuPortal: (base) => ({
                                                                            ...base,
                                                                            zIndex: 1050,
                                                                        }),
                                                                    }}
                                                                    options={[
                                                                        { value: null, label: "Select" }
                                                                    ]}
                                                                /> */}
                              </td>
                              <td>
                                <div
                                  className="text-center d-flex item-align-center justify-content-center"
                                  type="button"
                                  onClick={() =>
                                    openDeleteModal("BrandLine", {
                                      index,
                                      ID: ele.ID,
                                    })
                                  }
                                >
                                  {/* {formData.lines.length > 1 && ( */}

                                  <div className="me-2 pt-1">
                                    <i class="bi bi-arrow-right-circle"></i>
                                  </div>
                                  <div>
                                    <i
                                      className="bi bi-trash"
                                      style={{ fontSize: "1.2rem" }}
                                    ></i>
                                  </div>
                                  {/* )} */}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>

                  {/** */}
                  <div className="row">
                    <div className="d-flex justify-content-end">
                      <div className="d-flex">
                        <div>
                          <button
                            type="button"
                            className="cancel-btn me-2"
                            onClick={() => navigate(`/asset-allocation`)}
                          >
                            Cancel
                          </button>
                        </div>
                        <div>
                          <button
                            disabled={loading ? true : false}
                            type="submit"
                            className="custom-btn"
                          >
                            {loading ? (
                              <FaSpinner class="sm-spinner" />
                            ) : (
                              "Submit"
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

            </form>
        </div>

        <DeleteModal
          show={showDeleteModal}
          onClose={handleDeleteClose}
          onConfirm={handleModalDelete}
          message="Are you sure you want to delete this item?"
        />
      </>
    );
  }
};

export default AssetAllocationAdd;
